import React, { useEffect, useMemo, useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

import MomentPreview, { loadTranscript } from "../search/MomentPreview";
import { toResult } from "./askModel";
import { useProjects } from "./Moments";

/**
 * One of an answer's moments playing, with the others of its video on the timeline and the transcript following it;
 * the arrows go through all the answer's moments.
 * @param playing {moments, index, highlight}
 */
export default function MomentDialog({ playing, onIndex, onClose }) {
  const { t } = useTranslation();
  const { moments, index, highlight } = playing;
  const m = moments[index];
  const projectId = m.project_id;
  const info = useProjects(moments);
  const [transcript, setTranscript] = useState({ projectId: null, lines: null });
  const [hovered, setHovered] = useState(null);

  // the transcript's sentence ids, so that its lines that matched are marked
  useEffect(() => {
    let live = true;
    loadTranscript(projectId)
      .then((lines) => live && setTranscript({ projectId, lines }))
      .catch(() => live && setTranscript({ projectId, lines: [] }));
    return () => {
      live = false;
    };
  }, [projectId]);

  const results = useMemo(
    () => moments.map((x) => toResult(x, x.project_id === transcript.projectId ? transcript.lines : null)),
    [moments, transcript],
  );
  const r = results[index];
  const video = info[projectId];
  const terms = highlight || [];

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth className="askDialog" aria-label={t("Moment")}>
      <IconButton className="ak-dialog-close" size="small" title={t("Close")} aria-label={t("Close")} onClick={onClose}>
        <CloseIcon />
      </IconButton>
      {video ? (
        <MomentPreview
          r={r}
          video={video}
          pins={results.filter((x) => x.project_id === projectId)}
          index={index}
          total={results.length}
          hovered={hovered}
          onSelect={(id) => onIndex(results.findIndex((x) => x.id === id))}
          onStep={(d) => results[index + d] && onIndex(index + d)}
          onHover={setHovered}
          highlight={{ speech: terms, visual: terms }}
          videoSrc={() => video.video}
        />
      ) : (
        <div className="ak-dialog-loading">
          <CircularProgress />
        </div>
      )}
    </Dialog>
  );
}
